import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LangSwitcherType } from '../../../shared/components/lang-switcher/lang-switcher';
import { BusinessTypeService } from '../../services/business-type.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly environment = environment;
  readonly langSwitcherType = LangSwitcherType;

  constructor(public readonly businessTypeService: BusinessTypeService) {}
}
